<div @fadeInTrigger
     class="ion-padding"
     [class.hidden-item]="hide"
     (@fadeInTrigger.start)="captureStartEvent()">
    <ng-content></ng-content>
</div>
